<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
   name: "compUmatBaptis",
   props: ["triggerValidation"],
   data() {
      return {
         myOptions: {
            kriteria: umatOpt.kriteria,
            paroki: umatData.paroki,
            keuskupan: umatData.keuskupan,
         },
      };
   },
   computed: {
      isLoading() {
         return this.$store.state.isLoading;
      },
      ...mapState({
         umatBabtisItem: (state) => state.umatBaptis.item,
      }),
   },
   watch: {
      // eslint-disable-next-line no-unused-vars
      triggerValidation: function (_newVal, _oldVal) {
         this.trigger();
      },
   },
   methods: {
      validateState(ref) {
         if (
            this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)
         ) {
            return !this.veeErrors.has(ref);
         }
         return null;
      },
      validateStateCustom(ref) {
         if (
            this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)
         ) {
            if (this.veeErrors.has(ref)) {
               return { "is-invalid": true };
            } else {
               return { "is-valid": true };
            }
         }
         return null;
      },
      trigger() {
         this.$emit("validate", this.$validator.validateAll());
         this.$validator.validateAll();
      },
   },
};
</script>

<template>
   <div class="form theme-form">
      <div class="row">
         <div class="col-md-6">
            <div class="form-group">
               <label>
                  No Buku LB
                  <span class="text-danger">*</span>
               </label>
               <b-form-input
                  name="no_buku"
                  v-model="umatBabtisItem.no_buku"
                  v-validate="{ required: true }"
                  :state="validateState('no_buku')"
                  data-vv-as="No. Buku LB"
                  size="sm"
               ></b-form-input>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>
                  No LB
                  <span class="text-danger">*</span>
               </label>
               <b-form-input
                  name="no_lb"
                  v-model="umatBabtisItem.no_lb"
                  v-validate="{ required: true }"
                  :state="validateState('no_lb')"
                  data-vv-as="No. LB"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("no_lb")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>
                  Nama Baptis
                  <span class="text-danger">*</span>
               </label>
               <b-form-input
                  name="nama_baptis"
                  v-model="umatBabtisItem.nama_baptis"
                  v-validate="{ required: true }"
                  :state="validateState('nama_baptis')"
                  data-vv-as="Nama Baptis"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("nama_baptis")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-3">
            <div class="form-group">
               <label>Kriteria Baptis</label>
               <b-form-select
                  name="kriteria"
                  :options="myOptions.kriteria"
                  v-model="umatBabtisItem.kriteria"
                  v-validate="{ required: false }"
                  :state="validateState('kriteria')"
                  data-vv-as="Kriteria Baptis"
                  size="sm"
               ></b-form-select>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("kriteria")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-3">
            <div class="form-group">
               <label>Tanggal Baptis <span class="text-danger">*</span></label>
               <b-form-input
                  name="tanggal"
                  :state="validateState('tanggal')"
                  data-vv-as="Tanggal Baptis"
                  v-validate="{ required: true }"
                  v-model="umatBabtisItem.tanggal"
                  size="sm"
                  type="date"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("tanggal")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>Nama Wali Baptis 1</label>

               <b-form-input
                  name="wali"
                  v-model="umatBabtisItem.wali"
                  v-validate="{ required: false }"
                  :state="validateState('wali')"
                  data-vv-as="Wali Baptis 1"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("wali")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>Nama Wali Baptis 2</label>

               <b-form-input
                  name="wali2"
                  v-model="umatBabtisItem.wali2"
                  v-validate="{ required: false }"
                  :state="validateState('wali2')"
                  data-vv-as="Wali Baptis 2"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("wali2")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>
                  Imam Pembaptis
                  <span class="text-danger">*</span>
               </label>
               <b-form-input
                  name="pembaptis"
                  v-model="umatBabtisItem.pembaptis"
                  v-validate="{ required: true }"
                  :state="validateState('pembaptis')"
                  data-vv-as="Imam Pembaptis"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("pembaptis")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>
                  Keuskupan LB
                  <span class="text-danger">*</span>
               </label>
               <vue-typeahead-bootstrap
                  name="keuskupan_lb"
                  :class="validateStateCustom('keuskupan_lb')"
                  data-vv-as="Keuskupan LB"
                  v-validate="{ required: true }"
                  v-model="umatBabtisItem.keuskupan_lb"
                  :minMatchingChars="1"
                  :data="myOptions.keuskupan"
                  size="sm"
               />

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("keuskupan_lb")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>

         <div class="col-md-6">
            <div class="form-group">
               <label>
                  Paroki LB
                  <span class="text-danger">*</span>
               </label>
               <vue-typeahead-bootstrap
                  name="paroki_lb"
                  :class="validateStateCustom('paroki_lb')"
                  data-vv-as="Paroki LB"
                  v-validate="{ required: true }"
                  v-model="umatBabtisItem.paroki_lb"
                  :minMatchingChars="1"
                  :data="myOptions.paroki"
                  size="sm"
               />

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("paroki_lb")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>
         <div class="col-md-6">
            <div class="form-group">
               <label>
                  Tempat
                  <span class="text-danger">*</span>
               </label>
               <b-form-input
                  name="tempat"
                  v-model="umatBabtisItem.tempat"
                  v-validate="{ required: true }"
                  :state="validateState('tempat')"
                  data-vv-as="Tempat"
                  size="sm"
               ></b-form-input>

               <b-form-invalid-feedback>
                  {{
                     veeErrors.first("tempat")
                  }}
               </b-form-invalid-feedback>
            </div>
         </div>
      </div>
   </div>
</template>

